import React from "react";
import { colorFunctionalWhite, spacingM, spacingS } from "@rhumbix/rmbx_design_system_design_tokens";
import styled from "styled-components";
/**
 * A component for the footer used on form pages or in the right rail
 *
 * @param {string} justifyContent The value to pass to the justify-content style for the footer contents. This should be
 *      "flex-start" to left-justify the content or "flex-end" to right-justify it. By default it uses flex-end
 * @param {any} children The child elements to present in the component
 * @returns
 */
export const Footer = (props) => React.createElement(StyledFooter, { ...props }, props.children);
const StyledFooter = styled.div `
    background-color: ${colorFunctionalWhite};
    border-top: ridge;
    width: 100%;
    height: 75px;
    display: flex;
    justify-content: ${props => props.justifyContent ? props.justifyContent : "flex-end"}; 
    flex-direction: row;
    align-items: center;
    padding: 0 ${spacingM};

    button {
        margin-right: ${spacingS};
        height: 50px;
    }
`;
export default Footer;
